import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    BreadcrumbRadioButtonView,
    commonPageFieldList,
    commonPageFieldListSuccess
} from "../../../store/actions";
import CommonPurchaseList from "../../../components/Common/CommonPurchaseList"
import { useHistory } from "react-router-dom";
import * as report from '../../../Reports/ReportIndex'
import * as pageId from "../../../routes/allPageID";
import * as url from "../../../routes/route_url";
import { initialFiledFunc } from "../../../components/Common/validationFunction";
import * as mode from "../../../routes/PageMode"
import { getpdfReportdata } from "../../../store/Utilites/PdfReport/actions";
import { Edit_Credit_List_API, } from "../../../helpers/backend_helper";
import { Col, FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { Go_Button, PageLoadingSpinner } from "../../../components/Common/CommonButton";
import {
    CredietDebitType,
    Edit_CreditList_ID,
    GetCreditList,
    deleteCreditlistSuccess,
    delete_CreditList_ID,
    GetCreditListSuccess,
    Uploaded_Credit_Debit_EInvoiceSuccess,
    Cancel_Credit_Debit_EInvoiceSuccess,
    bulk_CreditNote_delete_ID,
    bulk_CreditNote_delete_ID_Success
} from "../../../store/Accounting/CreditRedux/action";
import { Retailer_List, Retailer_List_Success, getSupplierSuccess } from "../../../store/CommonAPI/SupplierRedux/actions";
import * as _cfunc from "../../../components/Common/CommonFunction"
import { C_DatePicker } from "../../../CustomValidateForm";
import { customAlert } from "../../../CustomAlert/ConfirmDialog";
import { allLabelWithBlank } from "../../../components/Common/CommonErrorMsg/HarderCodeData";
import { sideBarPageFiltersInfoAction } from "../../../store/Utilites/PartyDrodown/action";
import { alertMessages } from "../../../components/Common/CommonErrorMsg/alertMsg";
import GoodsCreditNote from "./GoodsCreditAndGoodsDebitAdd";
import CreditNoteAdd from "./CreditNoteAdd";
import Debit from "./DebitNoteAdd";
import CreditNote_1 from "./CreditNote1";

const CreditList = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func();
    const SystemData = _cfunc.loginSystemSetting()

    const fileds = {
        FromDate: currentDate_ymd,
        ToDate: currentDate_ymd,
        Customer: allLabelWithBlank,
        NoteType: allLabelWithBlank,
    }

    const [state, setState] = useState(() => initialFiledFunc(fileds))
    const hasPagePath = history.location.pathname

    const [pageMode, setpageMode] = useState(mode.defaultList)
    const [subPageMode] = useState(history.location.pathname);
    const [otherState, setOtherState] = useState({
        masterPath: '',
        buttonMsgLable: '',
        page_Id: '',
        MasterModal:''
    });

    const reducers = useSelector(
        (state) => ({
            listBtnLoading: (state.CredietDebitReducer.listBtnLoading || state.PdfReportReducers.ReportBtnLoading),
            GobuttonLoading: state.CredietDebitReducer.GobuttonLoading,
            tableList: state.CredietDebitReducer.CreditList,
            deleteMsg: state.CredietDebitReducer.deleteMsg,
            Uploaded_Credit_Debit_EInvoice: state.CredietDebitReducer.Uploaded_Credit_Debit_EInvoice,
            Cancel_Credit_Debit_EInvoice: state.CredietDebitReducer.Cancel_Credit_Debit_EInvoice,
            updateMsg: state.BOMReducer.updateMsg,
            postMsg: state.OrderReducer.postMsg,
            RetailerList: state.CommonAPI_Reducer.RetailerList,
            CreditDebitType: state.CredietDebitReducer.CreditDebitType,
            editData: state.CredietDebitReducer.editData,

            BulkCreditNotedeleteMsg: state.CredietDebitReducer.BulkCreditNotedeleteMsg,
            userAccess: state.Login.RoleAccessUpdateData,
            pageField: state.CommonPageFieldReducer.pageFieldList
        })
    );

    const { commonPartyDropSelect } = useSelector((state) => state.CommonPartyDropdownReducer);

    const { pageField,
        RetailerList,
        CreditDebitType,
        listBtnLoading,
        Cancel_Credit_Debit_EInvoice,
        Uploaded_Credit_Debit_EInvoice,
        GobuttonLoading,
        BulkCreditNotedeleteMsg } = reducers;

    const values = { ...state.values }

    const action = {
        editId: Edit_CreditList_ID,
        deleteId: delete_CreditList_ID,
        deleteSucc: deleteCreditlistSuccess
    }

    useEffect(() => {
        let page_Id = '';
        let page_Mode = mode.defaultList;
        let masterPath = '';
        let buttonMsgLable = ""
        let newBtnPath = '';
        let MasterModal = '';

        if (subPageMode === url.CREDIT_LIST) {
            page_Id = pageId.CREDIT_LIST;
            masterPath = url.CREDIT_NOTE;
            newBtnPath = url.CREDIT_NOTE;
            MasterModal = CreditNoteAdd;
            buttonMsgLable = "Credit"

        }
        else if (subPageMode === url.DEBIT_LIST) {
            page_Id = pageId.DEBIT_LIST;
            masterPath = url.DEBIT_NOTE;
            newBtnPath = url.DEBIT_NOTE;
            MasterModal = Debit;
            buttonMsgLable = "Debit"
        }
        else if (subPageMode === url.GOODS_CREDIT_LIST) {
            page_Id = pageId.GOODS_CREDIT_LIST;
            masterPath = url.GOODS_CREDIT_NOTE;
            newBtnPath = url.GOODS_CREDIT_NOTE;
            MasterModal = GoodsCreditNote;
            buttonMsgLable = "Credit"
        }
        else if (subPageMode === url.GOODS_DEBIT_LIST) {
            page_Id = pageId.GOODS_DEBIT_LIST;
            masterPath = url.GOODS_DEBIT_NOTE;
            newBtnPath = url.GOODS_DEBIT_NOTE;
            MasterModal = GoodsCreditNote;
            buttonMsgLable = "Debit"
        }
        else if (subPageMode === url.CREDIT_NOTE_LIST_1) {
            page_Id = pageId.CREDIT_NOTE_LIST_1;
            masterPath = url.CREDIT_NOTE_1;
            newBtnPath = url.CREDIT_NOTE_1;
            MasterModal = CreditNote_1;
            buttonMsgLable = "Credit"
        };

        setOtherState({ masterPath, newBtnPath, buttonMsgLable, page_Id , MasterModal})
        setpageMode(page_Mode)
        dispatch(commonPageFieldListSuccess(null))
        dispatch(commonPageFieldList(page_Id))
        dispatch(BreadcrumbRadioButtonView(true));

        return () => {
            dispatch(GetCreditListSuccess([]));
            dispatch(Retailer_List_Success([]));
            dispatch(getSupplierSuccess([]));
        }
    }, []);

    //   Note Type Api for Type identify
    useEffect(() => {
        const jsonBody = JSON.stringify({
            Company: _cfunc.loginCompanyID(),
            TypeID: 5
        });
        dispatch(CredietDebitType(jsonBody));
    }, []);

    // sideBar Page Filters Information
    useEffect(() => {

        dispatch(sideBarPageFiltersInfoAction([
            { label: "FromDate", content: _cfunc.date_dmy_func(values.FromDate), },
            { label: "ToDate", content: _cfunc.date_dmy_func(values.ToDate), },
            { label: "Customer", content: values.Customer.label, }
        ]));

    }, [state]);

    // Common Party Dropdown useEffect
    useEffect(() => {
        if (commonPartyDropSelect.value > 0) {
            const jsonBody = JSON.stringify({ //Retailer DropDown List Type 4 for credit list drop down
                Type: 4,
                PartyID: commonPartyDropSelect.value,
                CompanyID: _cfunc.loginCompanyID()
            });
            dispatch(Retailer_List(jsonBody));

        } else {
            partySelectOnChangeHandler()
        }
    }, [commonPartyDropSelect]);

    useEffect(() => {
        if ((CreditDebitType.length > 0) && !(commonPartyDropSelect.value === 0)) {
              goButtonHandler(true)
        };
    }, [CreditDebitType]);

    useEffect(() => {   // Uploaded EInvoice useEffect 
        if (Uploaded_Credit_Debit_EInvoice.Status === true && Uploaded_Credit_Debit_EInvoice.StatusCode === 200) {
            dispatch(Uploaded_Credit_Debit_EInvoiceSuccess({ Status: false }))
            goButtonHandler("event")
            customAlert({
                Type: 1,
                Message: JSON.stringify(Uploaded_Credit_Debit_EInvoice.Message),
            })
        }

        else if (Uploaded_Credit_Debit_EInvoice.Status === true) {
            dispatch(Uploaded_Credit_Debit_EInvoiceSuccess({ Status: false }))
            customAlert({
                Type: 3,
                Message: JSON.stringify(Uploaded_Credit_Debit_EInvoice.Message),
            })
        }
    }, [Uploaded_Credit_Debit_EInvoice]);

    useEffect(async () => {   // Uploaded Cancel E-Invoice useEffect 

        if (Cancel_Credit_Debit_EInvoice.Status === true && Cancel_Credit_Debit_EInvoice.StatusCode === 200) {
            dispatch(Cancel_Credit_Debit_EInvoiceSuccess({ Status: false }))
            goButtonHandler("event")
            customAlert({
                Type: 1,
                Message: Cancel_Credit_Debit_EInvoice.Message,
            })
            return
        }

        else if (Cancel_Credit_Debit_EInvoice.Status === true) {
            dispatch(Cancel_Credit_Debit_EInvoiceSuccess({ Status: false }))
            customAlert({
                Type: 3,
                Message: JSON.stringify(Cancel_Credit_Debit_EInvoice.Message),
            })
            return
        }
    }, [Cancel_Credit_Debit_EInvoice]);

    useEffect(async () => {   // Bulk Credit Note Delete useEffect 

        if (BulkCreditNotedeleteMsg.Status === true && BulkCreditNotedeleteMsg.StatusCode === 200) {
            dispatch(bulk_CreditNote_delete_ID_Success({ Status: false }))
            goButtonHandler("event")
            customAlert({
                Type: 1,
                Message: BulkCreditNotedeleteMsg.Message,
            })
            return
        }

        else if (BulkCreditNotedeleteMsg.Status === true) {
            dispatch(bulk_CreditNote_delete_ID_Success({ Status: false }))
            customAlert({
                Type: 3,
                Message: JSON.stringify(BulkCreditNotedeleteMsg.Message),
            })
            return
        }
    }, [BulkCreditNotedeleteMsg]);

    const customerOptions = RetailerList.map((index) => ({
        value: index.id,
        label: index.Name,
    }));

    customerOptions.unshift({
        value: "",
        label: " All"
    });

    function partySelectOnChangeHandler() {

        dispatch(GetCreditListSuccess([]));
        dispatch(Retailer_List_Success([]));
        setState((i) => {
            const a = { ...i }
            a.values.Customer = allLabelWithBlank
            a.values.NoteType = allLabelWithBlank
            a.hasValid.Customer.valid = true;
            a.hasValid.NoteType.valid = true;
            return a
        })
    }

    function noteType_BySubPageMode() {
        if (subPageMode === url.GOODS_CREDIT_LIST) {
            return CreditDebitType.find((index) => index.Name === "Goods CreditNote")?.id
        }
        else if (subPageMode === url.GOODS_DEBIT_LIST) {
            return CreditDebitType.find((index) => index.Name === "Goods DebitNote")?.id;
        }
        else if (subPageMode === url.CREDIT_LIST) {
            return CreditDebitType.find((index) => index.Name === "CreditNote")?.id
        }
        else if (subPageMode === url.DEBIT_LIST) {
            return CreditDebitType.find((index) => index.Name === "DebitNote")?.id;
        }
        else if (subPageMode === url.CREDIT_NOTE_LIST_1) {
            return CreditDebitType.find((index) => index.Name === "CreditNote")?.id;
        }
    }

    function goButtonHandler() {

        const jsonBody = JSON.stringify({
            FromDate: values.FromDate,
            ToDate: values.ToDate,
            CustomerID: values.Customer.value,
            PartyID: commonPartyDropSelect.value,
            NoteType: noteType_BySubPageMode(),
            Note: otherState.buttonMsgLable
        });
        dispatch(GetCreditList(jsonBody, hasPagePath));
    }

    function downBtnFunc(config) {

        config["ReportType"] = report.Credit;
        config["systemSetting"] = SystemData.CRDRNoteA4Print
        config["PaymentQr"] = SystemData.Qr_Image

        dispatch(getpdfReportdata(Edit_Credit_List_API, config))

    }

    function fromdateOnchange(e, date) {
        setState((i) => {
            const a = { ...i }
            a.values.FromDate = date;
            a.hasValid.FromDate.valid = true
            return a
        })
    }

    function todateOnchange(e, date) {
        setState((i) => {
            const a = { ...i }
            a.values.ToDate = date;
            a.hasValid.ToDate.valid = true
            return a
        })
    }

    function CustomerOnChange(e) {
        setState((i) => {
            const a = { ...i }
            a.values.Customer = e;
            a.hasValid.Customer.valid = true
            return a
        })
    }

    const selectSaveBtnHandler = (row = []) => {

        let ischeck = row.filter(i => (i.selectCheck && !i.forceSelectDissabled))
        if (!ischeck.length > 0) {
            customAlert({
                Type: 4,
                Message: alertMessages.selectOneCheckbox,
            });
            return
        }
        let idString = ischeck.map(obj => obj.id).join(',')
        let jsonBody = JSON.stringify({ CreditNote_ID: idString })
        dispatch(bulk_CreditNote_delete_ID({ jsonBody, btnId: row.btnId }))
    }

    const HeaderContent = () => {
        return (
            <div className="px-2   c_card_filter text-black" >
                <div className="row" >
                    <Col sm="3" className="">
                        <FormGroup className="mb- row mt-3 " >
                            <Label className="col-sm-5 p-2"
                                style={{ width: "83px" }}>FromDate</Label>
                            <Col sm="7">
                                <C_DatePicker
                                    name='FromDate'
                                    value={values.FromDate}
                                    onChange={fromdateOnchange}
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col sm="3" className="">
                        <FormGroup className="mb- row mt-3 " >
                            <Label className="col-sm-5 p-2"
                                style={{ width: "65px" }}>ToDate</Label>
                            <Col sm="7">
                                <C_DatePicker
                                    options={{
                                        minDate: (_cfunc.disablePriviousTodate({ fromDate: values.FromDate })),
                                        maxDate: "today",
                                        altInput: true,
                                        altFormat: "d-m-Y",
                                        dateFormat: "Y-m-d",
                                    }}
                                    value={_cfunc.ToDate({ FromDate: values.FromDate, Todate: values.ToDate })}
                                    name="ToDate"
                                    onChange={todateOnchange}
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col sm="5">
                        <FormGroup className="mb-2 row mt-3 " >
                            <Label className="col-md-4 p-2"
                                style={{ width: "115px" }}>Customer</Label>
                            <Col sm="5">
                                <Select
                                    name="Customer"
                                    classNamePrefix="select2-Customer"
                                    value={values.Customer}
                                    options={customerOptions}
                                    onChange={CustomerOnChange}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 2 })
                                    }}
                                />
                            </Col>
                        </FormGroup>
                    </Col >
                    <Col sm="1" className="mt-3 ">
                        <Go_Button onClick={goButtonHandler} loading={GobuttonLoading} />
                    </Col>
                </div>
            </div>
        )
    }

    return (
        <React.Fragment>
            <PageLoadingSpinner isLoading={(listBtnLoading || !pageField)} />
            <div className="page-content">
                {
                    (pageField) ?
                        <CommonPurchaseList
                            action={action}
                            reducers={reducers}
                            showBreadcrumb={false}
                            masterPath={otherState.masterPath}
                            newBtnPath={otherState.newBtnPath}
                            makeBtnShow={otherState.makeBtnShow}
                            pageMode={pageMode}
                            HeaderContent={HeaderContent}
                            goButnFunc={goButtonHandler}
                            downBtnFunc={downBtnFunc}
                            ButtonMsgLable={otherState.buttonMsgLable}
                            deleteName={"FullNoteNumber"}
                            MasterModal={otherState.MasterModal}
                            totalAmountShow={true}
                            masterPageId={otherState.page_Id}
                            selectCheckParams={{
                                // isShow: ((subPageMode === url.GOODS_CREDIT_LIST)),
                                selectSaveBtnHandler: selectSaveBtnHandler,
                                selectSaveBtnLabel: "Delete",
                                selectHeaderLabel: "Select",
                                selectSaveBtnLoading: listBtnLoading
                            }}

                        />
                        : null
                }
            </div>
        </React.Fragment>
    )
}

export default CreditList;